module.exports = __webpack_public_path__ + "static/media/green-leaves.68b4f295.jpg";